"use client"

import { useState } from "react"
import axios from "axios"
import { Link } from "react-router-dom"
import { Box, TextField, Button, Typography, Paper, Alert, CircularProgress } from "@mui/material"
import BaseURL from "../../api/AppURL";

const ForgotPassword = () => {
  const [email, setEmail] = useState("")
  const [message, setMessage] = useState("")
  const [error, setError] = useState("")
  const [loading, setLoading] = useState(false)

  const handleSubmit = async (e) => {
    e.preventDefault()
    setMessage("")
    setError("")
    setLoading(true)

    try {
      const res = await axios.post(`${BaseURL}/forgot-password`, { email })
      setMessage(res.data.message || "Password reset link sent to your email.")
    } catch (err) {
      if (err.response && err.response.data && err.response.data.errors) {
        // Laravel validation errors (status 422)
        const errors = err.response.data.errors
        let errorMessage = ""
        for (const key in errors) {
          errorMessage += `${errors[key].join(" ")}\n`
        }
        setError(errorMessage.trim())
      } else if (err.response && err.response.data && err.response.data.message) {
        // Other API errors with a message
        setError(err.response.data.message)
      } else {
        // Generic error for network issues or unexpected responses
        setError("Failed to send reset link. Please check your network and try again.")
      }
      console.error("Forgot password error:", err)
    } finally {
      setLoading(false)
    }
  }

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        backgroundColor: "#f5f5f5",
      }}
    >
      <Paper elevation={3} sx={{ p: 4, maxWidth: 400, width: "100%", borderRadius: 2 }}>
        <Typography variant="h5" component="h1" gutterBottom sx={{ mb: 3, textAlign: "center", fontWeight: "bold" }}>
          Forgot Password
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3, textAlign: "center" }}>
          Enter your email address to receive a password reset link.
        </Typography>
        <form onSubmit={handleSubmit}>
          <TextField
            label="Email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            fullWidth
            margin="normal"
            variant="outlined"
            required
            error={!!error} // এরর থাকলে টেক্সটফিল্ডে এরর স্টেট দেখাবে
            helperText={error} // এরর মেসেজ দেখাবে
            sx={{ mb: 3 }}
          />
          <Button
            type="submit"
            variant="contained"
            fullWidth
            sx={{ mb: 2, py: 1.5 }}
            disabled={loading}
            startIcon={loading ? <CircularProgress size={20} color="inherit" /> : null}
          >
            {loading ? "Sending..." : "Send Reset Link"}
          </Button>
          <Box sx={{ textAlign: "center" }}>
            <Link to="/login" style={{ textDecoration: "none" }}>
              <Button variant="text" sx={{ textTransform: "none" }}>
                Back to Login
              </Button>
            </Link>
          </Box>
          {message && (
            <Alert severity="success" sx={{ mt: 3 }}>
              {message}
            </Alert>
          )}
          {error &&
            !message && ( // শুধুমাত্র এরর দেখাবে যদি কোনো সফলতার মেসেজ না থাকে
              <Alert severity="error" sx={{ mt: 3, whiteSpace: "pre-wrap" }}>
                {error}
              </Alert>
            )}
        </form>
      </Paper>
    </Box>
  )
}

export default ForgotPassword
